const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default localTimeZone;
